import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import logo from "../assets/logo/logobg.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const menuLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/aboutus" },
    { name: "Portfolio", path: "/portfolio" },
    { name: "Reviews", path: "/services" },
    { name: "Contact", path: "/contactform" },
  ];

  return (
    <nav className="relative w-full z-50">
      {/* Glass background */}
      <div
        className="absolute inset-0"
        style={{
          background: "rgba(11,14,17,0.7)",
          backdropFilter: "blur(12px)",
        }}
      />

      {/* Bottom gradient line */}
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-[#00F5A0] via-[#00CFFF] to-transparent" />

      {/* Navbar content */}
      <div className="relative flex items-center justify-between px-6 md:px-12 h-24">
        {/* Logo */}
        <div className="relative flex items-center">
          {/* Soft glow behind logo */}
          <div className="absolute -inset-4 rounded-full bg-[#00F5A0]/10 blur-2xl" />
          <img
            src={logo}
            alt="CraftTech"
            className="relative w-16 md:w-24"
          />
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-4">
          {menuLinks.map((link) => {
            const isActive = location.pathname === link.path;

            return (
              <Link key={link.name} to={link.path}>
                <button
                  className={`px-6 py-3 rounded-full text-sm md:text-base font-semibold transition-all duration-300
                    ${
                      isActive
                        ? "text-[#00F5A0] shadow-[0_0_14px_rgba(0,245,160,0.35)]"
                        : "text-white/80 hover:text-white hover:scale-105"
                    }`}
                >
                  {link.name}
                </button>
              </Link>
            );
          })}
        </div>

        {/* Mobile Toggle */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-white z-50"
        >
          {isOpen ? <HiX size={32} /> : <HiMenu size={32} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div
          className="md:hidden absolute top-24 left-1/2 -translate-x-1/2 w-[90%] rounded-3xl p-6 space-y-4"
          style={{
            background: "rgba(11,14,17,0.9)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(0,245,160,0.25)",
          }}
        >
          {menuLinks.map((link) => {
            const isActive = location.pathname === link.path;

            return (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
              >
                <div
                  className={`px-6 py-3 rounded-2xl text-center font-semibold transition-all
                    ${
                      isActive
                        ? "text-black bg-[#00F5A0] shadow-[0_0_18px_rgba(0,245,160,0.6)]"
                        : "text-white/80 hover:text-white hover:bg-white/5"
                    }`}
                >
                  {link.name}
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </nav>
  );
}
